import { Row, Col, Divider, Avatar, List, Button, Input } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CLASS_ACTIONS } from "../redux/class/action";
import ClassForm from "../components/forms/Class";
import { AntDrawer } from "../components/drawer/Drawer";

function Classes() {
  const dispatch = useDispatch();
  const { Search } = Input;

  const [open, setOpen] = useState(false);
  const [classesArray, setClassesArray] = useState([]);
  const [updateData, setUpdateData] = useState(null);
  const [isUpdate, setIsUpdate] = useState(false);

  const [search, setSearch] = useState("");

  const {
    data,
    class: classData,
    loading,
  } = useSelector((reducers) => reducers.classReducer);

  const loadData = () => {
    dispatch({
      type: CLASS_ACTIONS.GET_CLASS,
      payload: {
        queryParams: {
          query: search,
        },
      },
    });
  };

  useEffect(() => {
    loadData();
  }, [search]);

  useEffect(() => {
    setClassesArray(data);
  }, [data]);

  useEffect(() => {
    setUpdateData(classData);
  }, [classData]);

  const handleEdit = (item) => {
    setIsUpdate(true);

    dispatch({
      type: CLASS_ACTIONS.GET_CLASS_BY_ID,
      payload: {
        path: {
          classId: item.id,
        },
      },
    });

    setOpen(true);
  };

  const handleDelete = (item) => {
    dispatch({
      type: CLASS_ACTIONS.DELETE_CLASS,
      payload: {
        path: {
          classId: item.id,
        },
      },
    });
  };

  const handleUpdateComplete = (item) => {
    setIsUpdate(item);
  };

  const onSearch = (e) => setSearch(e.target.value);

  const handleDrawerClose = () => {
    setOpen(false);
    setIsUpdate(false);
    setUpdateData(null);
  };

  return (
    <>
      <div className="tabled">
        <Row gutter={[24, 0]}>
          <Col
            xs="24"
            xl={24}
            style={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button type="primary" onClick={() => setOpen(true)}>
              Add Class
            </Button>
          </Col>
          <Col xs="24" xl={24}>
            <Row gutter={[24, 0]}>
              <Col xs="24" xl={24}>
                <Divider orientation="left" plain>
                  Classes
                </Divider>
                <Search
                  placeholder="Search class"
                  value={search}
                  onChange={onSearch}
                  enterButton
                />
                <List
                  itemLayout="horizontal"
                  dataSource={classesArray}
                  renderItem={(item, index) => (
                    <List.Item
                      actions={[
                        <Button type="link" onClick={() => handleEdit(item)}>
                          Edit
                        </Button>,
                        <Button
                          type="link"
                          style={{ color: "red" }}
                          onClick={() => handleDelete(item)}
                        >
                          Delete
                        </Button>,
                      ]}
                    >
                      <List.Item.Meta
                        avatar={
                          <Avatar
                            src={
                              item.image?.length ? item.image[0]?.preview : null
                            }
                          />
                        }
                        title={item.name}
                        description={item.designation}
                      />
                      {item.text}
                    </List.Item>
                  )}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
      <AntDrawer size="large" open={open} onClose={handleDrawerClose}>
        <ClassForm
          key={open}
          updateData={updateData}
          isUpdate={isUpdate}
          isUpdateComplete={handleUpdateComplete}
        />
      </AntDrawer>
    </>
  );
}

export default Classes;
